var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 126,
    viewBox: "0 0 186 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.8791 113.472C73.8644 114.16 72.9995 115.064 72.3457 116.121C72.1987 116.359 71.8577 116.359 71.71 116.122C71.0534 115.067 70.1861 114.165 69.1695 113.48C68.9439 113.328 68.9434 112.981 69.1687 112.828C70.1834 112.14 71.0483 111.236 71.702 110.179C71.849 109.941 72.19 109.94 72.3377 110.178C72.9943 111.233 73.8616 112.135 74.8782 112.82C75.1039 112.972 75.1044 113.319 74.8791 113.472Z",
    fill: "url(#paint0_linear_3729_42498)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 73.4718C183.864 74.1597 183 75.0642 182.346 76.1212C182.199 76.3589 181.858 76.3594 181.71 76.1221C181.053 75.0671 180.186 74.165 179.17 73.4801C178.944 73.3281 178.943 72.9806 179.169 72.8279C180.183 72.14 181.048 71.2355 181.702 70.1785C181.849 69.9409 182.19 69.9404 182.338 70.1777C182.994 71.2327 183.862 72.1348 184.878 72.8197C185.104 72.9718 185.104 73.3192 184.879 73.4718Z",
    fill: "url(#paint1_linear_3729_42498)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6933 36.0622C8.84759 37.2633 7.27455 38.8426 6.08538 40.6882C5.81793 41.1032 5.19777 41.1041 4.92911 40.6898C3.73477 38.8476 2.15742 37.2725 0.308315 36.0765C-0.102082 35.8112 -0.102943 35.2044 0.306765 34.9378C2.15243 33.7367 3.72547 32.1574 4.91447 30.3118C5.18192 29.8968 5.80208 29.8959 6.07074 30.3102C7.26508 32.1524 8.8426 33.7275 10.6915 34.9235C11.1021 35.189 11.103 35.7956 10.6933 36.0622Z",
    fill: "url(#paint2_linear_3729_42498)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.429 103.944C111.838 104.329 111.333 104.836 110.952 105.428C110.866 105.561 110.667 105.561 110.581 105.428C110.198 104.838 109.692 104.332 109.099 103.949C108.967 103.864 108.967 103.669 109.098 103.584C109.69 103.198 110.195 102.692 110.576 102.1C110.662 101.967 110.861 101.967 110.947 102.099C111.33 102.69 111.836 103.195 112.429 103.579C112.561 103.664 112.561 103.859 112.429 103.944Z",
    fill: "#FD5382"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4295 35.9442C79.8375 36.3294 79.3331 36.836 78.9517 37.4279C78.8659 37.561 78.667 37.5612 78.5808 37.4284C78.1978 36.8376 77.6919 36.3324 77.0989 35.9488C76.9673 35.8637 76.967 35.6691 77.0984 35.5836C77.6903 35.1984 78.1948 34.6919 78.5761 34.1C78.6619 33.9669 78.8608 33.9666 78.947 34.0995C79.33 34.6903 79.8359 35.1955 80.4289 35.579C80.5606 35.6642 80.5609 35.8587 80.4295 35.9442Z",
    fill: "#FDAD28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3729_42498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5672 10.9985C27.9107 8.98877 28.952 4.50302 31.5206 4.07276C32.2901 3.94388 33.0856 4.15606 33.6468 4.69795C40.4594 11.2759 40.6345 20.7839 41.9703 26.3793C41.9898 26.4608 41.9995 26.5424 41.9995 26.6262C41.9995 27.604 40.8205 28.0178 40.2569 27.2187C36.8864 22.4401 33.5592 15.8419 29.5672 10.9985Z",
    fill: "url(#paint3_linear_3729_42498)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3729_42498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.978 117.072L146.482 114.804L147.364 114.048L152.404 115.182L154.042 118.332C154.43 118.987 154.369 120.736 154.042 122.364C153.723 123.945 152.866 123.707 152.278 123.371C150.64 122.196 147.188 119.718 146.482 119.214C145.776 118.71 145.852 117.576 145.978 117.072Z",
    fill: "url(#paint4_linear_3729_42498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.635 108.598C136.788 111.521 133.815 115.695 133.059 117.417C132.757 118.324 133.689 118.215 134.193 118.047C134.445 117.837 136.562 117.014 143.013 115.401C149.464 113.789 153.176 116.997 154.226 118.803C152.798 114.183 148.481 105.674 142.635 108.598Z",
    fill: "#FFD945"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4991 75.0103C52.3108 76.826 52.8453 79.7812 52.886 81.0318C53.8361 81.2414 55.74 81.1296 57.4377 77.2249C59.1354 73.3201 55.1671 72.0136 53.0231 71.1808C50.8791 70.3481 49.5321 67.5191 49.4042 67.144C48.7244 67.7798 48.4702 69.2321 48.4281 69.8787C48.3635 70.8327 48.6874 73.1946 50.4991 75.0103Z",
    fill: "url(#paint5_linear_3729_42498)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3729_42498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.284 26.2154C133.193 22.3622 133.106 18.3297 139.057 17.177C139.749 17.0429 140.423 17.4461 140.693 18.0979C141.108 19.1034 140.398 20.2085 139.329 20.4144C134.548 21.3356 134.455 24.2762 134.396 26.4879L134.284 26.2154Z",
    fill: "url(#paint6_linear_3729_42498)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3729_42498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.268 25.6472C134.953 27.9602 135.38 30.4106 132.253 31.017C131.79 31.1068 131.334 30.8621 131.096 30.4547C130.624 29.6481 131.206 28.6447 132.113 28.4192C134.063 27.9343 134.294 26.7679 134.279 25.5887L134.268 25.6472Z",
    fill: "url(#paint7_linear_3729_42498)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3729_42498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.54 62.6039C110.839 63.997 118.575 67.4584 115.412 79.7967C115.044 81.2323 113.672 82.1492 112.192 82.0748C109.909 81.9601 108.449 79.6167 109.019 77.4026C111.569 67.4948 106.069 64.6724 101.921 62.5728L102.54 62.6039Z",
    fill: "url(#paint8_linear_3729_42498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.632 63.0834C98.6236 62.3037 93.5866 60.91 95.247 54.427C95.4931 53.4665 96.3678 52.8212 97.3556 52.735C99.3117 52.5645 100.694 54.5722 100.306 56.4972C99.4737 60.6362 101.481 62.124 103.734 63.1563L103.632 63.0834Z",
    fill: "url(#paint9_linear_3729_42498)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3729_42498",
    x: 27.7586,
    y: 4.03613,
    width: 15.2488,
    height: 25.6204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.00796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.50398
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3729_42498",
    x: 131.992,
    y: 108,
    width: 23.3265,
    height: 17.6331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.00796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.50398
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3729_42498",
    x: 128.912,
    y: 17.1514,
    width: 13.9171,
    height: 18.4196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00796
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3729_42498",
    x: 125.636,
    y: 25.5889,
    width: 14.4122,
    height: 16.5338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79577
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.64589
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3729_42498",
    x: 92.4044,
    y: 51.2127,
    width: 26.2512,
    height: 34.3943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.00796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25995
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3729_42498",
    x1: 68.9987,
    y1: 113.161,
    x2: 75.0465,
    y2: 113.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B62CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8F4EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3729_42498",
    x1: 178.999,
    y1: 73.1609,
    x2: 185.046,
    y2: 73.1433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B62CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8F4EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3729_42498",
    x1: -0.0022814,
    y1: 35.5192,
    x2: 10.9977,
    y2: 35.4859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#FFB443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#FFB443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3729_42498",
    x1: 35.7626,
    y1: 13.6872,
    x2: 31.1929,
    y2: 16.9836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF749A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3729_42498",
    x1: 150.103,
    y1: 114.048,
    x2: 150.892,
    y2: 123.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166984,
    stopColor: "#F09A0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3729_42498",
    x1: 54.0342,
    y1: 82.002,
    x2: 47.4183,
    y2: 66.9787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BE1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#1FDACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#67ECE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BE1D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3729_42498",
    x1: 135.198,
    y1: 19.0175,
    x2: 138.561,
    y2: 23.4359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D153FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3729_42498",
    x1: 133.959,
    y1: 30.1182,
    x2: 131.839,
    y2: 27.4614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E53FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3729_42498",
    x1: 116.248,
    y1: 72.7855,
    x2: 101.446,
    y2: 72.0419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5E0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3729_42498",
    x1: 94.8844,
    y1: 57.3609,
    x2: 104.002,
    y2: 57.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5E0FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti2);
export default __webpack_public_path__ + "static/media/confetti2.205da4c48a5f3d863914e9fac273f9ba.svg";
export { ForwardRef as ReactComponent };